<template>
  <BranchForm
    buttonTitle="Создать"
    :cardTitle="$t('pages.newBranch')"
    @saveBranch="handleAddBranch"
    @saveBankAccount="handleAddBank"
  />
</template>

<script>
import BranchForm from './components/BranchForm.vue'
import { RESET_CURRENT_BRANCH } from '@/store/mutations.types'
export default {
  data() {
    return {
      // loaded: false,
    }
  },
  components: {
    BranchForm
  },
  created() {
    this.$store.commit(RESET_CURRENT_BRANCH)
    // await this.initBranchData(this.$route.params.id)
  },
  // mounted() {
  //   this.initBranchData(this.$route.params.id)
  // },
  watch: {
    // '$route.params.id': function(id) {
    //   this.initBranchData(id)
    // }
  },
  methods: {
    handleAddBranch(data) {
      this.$km_track('AddBranch', 'Click', 'Create', data)
    },
    handleAddBank(label) {
      this.$km_track('AddBranch', 'Click', 'AddBranchAccount')
    }
    // initBranchData(id) {
    //   this.loaded = false
    //   this.$vs.loading()
    //   this.$store.dispatch(BRANCH_FETCH, id).then(() => {
    //     this.$vs.loading.close()
    //     this.loaded = true
    //   })
    // },
    // toggleTab(currentTab) {
    //   this.tabs.map(tab => {
    //     tab.id === currentTab.id ? tab.active = true : tab.active = false
    //   })
    // },
    // createNewBranch() {
    //   this.popupActive = true
    // },
    // inspectAnalytics() {
    //   this.$router.push({ name: 'branchAnalytics' })
    // },
    // inspectUsers() {
    //   this.$router.push({ name: 'branchEmployees', params: { extra: false }})
    // },
    // inspectUserCards() {
    //   this.$router.push({ name: 'branchEmployees', params: { extra: true }})
    // },
    // updateBranch() {
    //   this.$vs.loading()
    //   setTimeout(() => {
    //     this.$vs.loading.close()
    //     this.$vs.notify({
    //       title: 'Данные сохранены',
    //       text: 'Информация о заведении обновлена',
    //     })
    //   }, 1000)
    // }
  }
}
</script>

<style lang="scss">
#branch-info {
    .action-button {
        cursor: pointer;
        &.active {
            -webkit-box-shadow: 0 10px 25px -10px rgba(5,37,85,0.85);
            -moz-box-shadow: 0 10px 25px -10px rgba(5,37,85,0.85);
            box-shadow: 0 10px 25px -10px rgba(5,37,85,0.85);
        }
    }
}
</style>
